import { Select } from "@chakra-ui/react";
import styled from "styled-components";

export const PropostasImportantesContainer = styled.div`
  margin-top: 15px;
  background-color: #f9fbfb;
`;
export const PropostasImportantesContainerText = styled.div`
  background-color: #ffbd37;
  padding: 15px 0;
  h1 {
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
  }
`;
export const ContentLoading = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 99999;
  background-color: #ffffff;
`;
export const ContentLoadingContent = styled.div`
  width: 100px;
  height: 100px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  top: 20%;
  background-color: #fff;
`;
export const ContentFilter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 0;
`;
export const ContentFilterSelectVendedor = styled.div`
  width: 200px;
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
`;
export const SelectBox = styled(Select)`
  font-family: Akrobat SemiBold;
  box-shadow: none !important;
`;
export const ButtonFilter = styled.button`
  background-color: #ffbd37;
  color: #fff;
  width: 6rem;
  border: none;
  border-radius: 5px;
  padding: 0 13px;
`;
export const ContentTables = styled.div`
  min-height: 50vh;

  thead {
    th {
      padding: 10px 20px;
      color: #ffbd37;
      font-size: 14px;
      font-weight: 400;
    }
  }

  tbody {
    tr {
      background-color: #f6f6f6;
      td {
        padding: 0 20px;
        text-align: center;
        font-size: 14px;
        height: 30px;
      }
    }
  }
`;
export const ContentTablesHighlights = styled.div`
  display: flex;
  justify-content: center;
  font-family: "Roboto";
  margin: 40px 0;
`;
export const ContentTablesItem = styled.div`
  background-color: #ffbd37;
  color: #fff;
  width: 25%;
  height: 60px;
  margin-right: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: "Akrobat";
  padding: 0 20px;
  border-radius: 5px;
`;
export const ContentTablesName = styled.p`
  font-size: 20px;
  font-weight: 300;
`;
export const Span = styled.span`
  background-image: url("../images/icon_folder_green.png");
`;
// export const  = styled.div``;
